import { useState } from 'react';
import VisitorList from '../components/VisitorList';
import ChatContainer from '../components/ChatContainer';
import { VisitorResponse } from '../types';

export default function ChatExplorer() {
  const [selectedVisitor, setSelectedVisitor] =
    useState<VisitorResponse | null>(null);

  const handleFlagChange = (isFlagged: boolean) => {
    setSelectedVisitor((prev) =>
      prev ? { ...prev, is_flagged: isFlagged } : prev,
    );
  };

  return (
    <div className="flex h-screen flex-col">
      <div className="border-b border-gray-200 bg-white px-6 py-3">
        <h1 className="text-lg font-semibold text-gray-900">Chat Explorer</h1>
      </div>
      <div className="flex flex-1 overflow-hidden bg-white shadow-sm">
        <VisitorList
          selectedVisitorId={selectedVisitor?.visitor_id}
          onSelectVisitor={setSelectedVisitor}
        />

        <div className="flex flex-1 flex-col bg-gray-50">
          {selectedVisitor ? (
            <ChatContainer
              visitor={selectedVisitor}
              onFlagChange={handleFlagChange}
            />
          ) : (
            <div className="flex h-full items-center justify-center">
              <p className="text-gray-500">Select a visitor to view messages</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
